<!--
    People Filter
    This component is used to filter the people.

    Visual:
    - The component is a dropdown with a button to open it
    - The dropdown contains a list of filters

    Props:
    - filter: The current filter (modelValue)

    Events:
    - update: Emitted when the filter is updated
 -->

<template>
  <div>
    <SmDropdown :close-on-click-inside="false">
      <template #trigger>
        <!-- Button -->
        <SmButton type="primary" size="small" outline class="filter-button">
          <Filter class="filter-icon mr-2" :size="18" />
          <span> {{ i18n.t('filter') }} </span>
          <span v-if="numberOfFiltersSet > 0"
            >&nbsp;({{ numberOfFiltersSet }})</span
          >
        </SmButton>
      </template>

      <!-- Dropdown Content -->

      <div class="flex flex-col gap-2 p-3">
        <div class="flex items-center gap-2">
          <SmSwitch v-model:model-value="modelValue.hasApps" />
          <p>{{ i18n.t('hidePersonsWithoutApp') }}</p>
        </div>

        <div class="flex items-center gap-2">
          <SmSwitch v-model:model-value="modelValue.withoutApps" />
          <p>{{ i18n.t('hidePersonsWithApp') }}</p>
        </div>
        <!-- Include Deactivated licenses in app count -->
        <!-- <span>{{ i18n.t('includeDeactivatedLicenses') }}: </span>
          <SmCheckbox
            v-model:model-value="modelValue.includeDeactivatedLicenses" /> -->
      </div>
    </SmDropdown>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { Filter } from 'lucide-vue-next'
  import { PersonFilters } from '@/stores/person/person.filter'

  export type PersonFilterType = {
    withoutApps: boolean
    hasApps: boolean
    includeDeactivatedLicenses: boolean
    tags: string[]
  }

  const i18n = useI18n()

  const numberOfFiltersSet = computed(() => {
    let number = 0
    Object.values(modelValue.value).forEach((value) => {
      if (value === true) number++
    })
    return number
  })

  const modelValue = defineModel('modelValue', {
    type: Object as PropType<PersonFilters>,
    default: () => {
      return {
        hideUsersWithoutApp: true,
        hideUsersWithApp: false,
        tags: [],
      }
    },
  })
</script>

<style scoped lang="scss">
  .filter-wrapper {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    justify-items: start;
    padding: 10px;
    gap: 10px;
  }
</style>
